export const OPEN_SOURCE_INSTALLATION_INFO = 'open source';
